module.exports = __webpack_public_path__ + "img/white-lily.db355724.webp";